import { Component } from 'react'
import { RouterProps, withRouter } from '../../../../insfrastructure/utils/with-router-component'
import './styles.sass'
import { Input } from '../../../components/input'
import { ErrorMessage, emptyField, errorsLength, formatErrors } from '../../../../insfrastructure/utils/form-validators'
import { Select } from '../../../components/select'
import { DateOfBirthField } from '../../../components/date-of-birth-field'
import { parseJwt } from '../../../../insfrastructure/utils/JWTParser'
import { getAuthToken } from '../../../../insfrastructure/services/token-manager'

class CompanyUserProfile extends Component<RouterProps> {

  state: any = {
    form: {

    },
    formErrors: {}
  }

  componentDidMount() {
    // Bloqueio temporário: em_job_manager não pode acessar o perfil até ter seu próprio perfil
    const token = getAuthToken();
    if (token) {
      const parsedJWT = parseJwt(token);
      if (parsedJWT?.profiles?.includes('em_job_manager')) {
        this.props.navigate('/offers/panel');
        return;
      }
    }
  }

  onSubmit = () => {
    const errors = formatErrors({
      fullname: [emptyField(this.state.form.fullname, 'string')],
      phone: [emptyField(this.state.form.phone, 'string')],
      date: [emptyField(this.state.form.date, 'string')],
      city: [emptyField(this.state.form.city, 'string')],
      marital_status: [emptyField(this.state.form.marital_status, 'string')],
      deficiency: [emptyField(this.state.form.deficiency, 'string')],
      gender: [emptyField(this.state.form.gender, 'string')],
      uf: [emptyField(this.state.form.uf, 'string')]
    });

    this.setState({ formErrors: errors }, () => {
      if (errorsLength(errors) > 0) {
        const firstErrorElement = document.querySelector('.errors .error') as HTMLElement | null;
        if (firstErrorElement && typeof firstErrorElement.scrollIntoView === 'function') {
          firstErrorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    });

    if(errorsLength(errors) > 0) return;

    try {
      this.setState({ loading: true });
        setTimeout(() => {
          this.setState({ loading: false });
        }, 200);
    } catch (error) {
        this.setState({ loading: false });
    }
  }

  render() {
    return (
      <div className='company-user-profile company-page'>
        <div className='block'>
            <h3>Dados Pessoais do Responsável</h3>
            <div className='columns'>
              <div className='column'>
                <Input
                name='fullname'
                label='Nome Completo'
                onChange={e => this.setState({ form: { ...this.state.form, fullname: e }, formErrors: { ...this.state.formErrors, fullname: [] } })}/>
                <ErrorMessage errors={this.state.formErrors['fullname']} />
                <Input
                name='phone'
                mask='(99) 99999-9999'
                label='Celular'
                onChange={e => this.setState({ form: { ...this.state.form, phone: e }, formErrors: { ...this.state.formErrors, phone: [] } })}/>
                <ErrorMessage errors={this.state.formErrors['phone']} />
                <DateOfBirthField
                name='date'
                label='Data de Nascimento'
                value={this.state.form.date}
                onChange={e => this.setState({ form: { ...this.state.form, date: e }, formErrors: { ...this.state.formErrors, date: [] } })}
                errors={this.state.formErrors['date']} />
                <Select
                name='city'
                label='Cidade'
                options={[
                  {
                    label: 'São Paulo',
                    value: 'São Paulo'
                  }
                ]}
                onChange={e => this.setState({ form: { ...this.state.form, city: e } })}/>
                <ErrorMessage errors={this.state.formErrors['city']} />
              </div>
              <div className='column'>
                <Input
                name='marital_status'
                label='Estado Civil'
                onChange={e => this.setState({ form: { ...this.state.form, marital_status: e }, formErrors: { ...this.state.formErrors, marital_status: [] } })}/>
                <ErrorMessage errors={this.state.formErrors['marital_status']} />
                <Select
                name='deficiency'
                label='Deficiência'
                options={[
                  {
                    label: 'Deficiência física',
                    value: 'Deficiência física'
                  },
                  {
                    label: 'Deficiência auditiva e surdez',
                    value: 'Deficiência auditiva e surdez'
                  },
                  {
                    label: 'Deficiência visual',
                    value: 'Deficiência visual'
                  },
                  {
                    label: 'Deficiência intelectual/mental',
                    value: 'Deficiência intelectual/mental'
                  },
                  {
                    label: 'Deficiência múltipla',
                    value: 'Deficiência múltipla'
                  },
                  {
                    label: 'Mobilidade reduzida',
                    value: 'Mobilidade reduzida'
                  },
                  {
                    label: 'Outro',
                    value: 'Outro'
                  },
                  {
                    label: 'Não tenho deficiência',
                    value: 'Não tenho deficiência'
                  }
                ]}
                onChange={e => this.setState({ form: { ...this.state.form, deficiency: e }, formErrors: { ...this.state.formErrors, deficiency: [] } })}/>
                {this.state.form.deficiency === 'Outro' &&
                <>
                  <Input
                  name='expecific_deficiency'
                  label='Expecificar Deficiência'
                  onChange={e => this.setState({ form: { ...this.state.form, expecific_deficiency: e }, formErrors: { ...this.state.formErrors, expecific_deficiency: [] } })}/>
                  <ErrorMessage errors={this.state.formErrors['expecific_deficiency']} />
                </>}
                <Input
                name='gender'
                label='Gênero'
                onChange={e => this.setState({ form: { ...this.state.form, gender: e }, formErrors: { ...this.state.formErrors, gender: [] } })}/>
                <ErrorMessage errors={this.state.formErrors['gender']} />
                <Select
                name='uf'
                label='Estado'
                options={[
                  {
                    label: 'São Paulo',
                    value: 'São Paulo'
                  }
                ]}
                onChange={e => this.setState({ form: { ...this.state.form, uf: e }, formErrors: { ...this.state.formErrors, uf: [] } })}/>
                <ErrorMessage errors={this.state.formErrors['uf']} />
              </div>
            </div>
            <button className='primary' onClick={this.onSubmit}>Confirmar</button>
        </div>
      </div>
    )
  }
}

export default withRouter(CompanyUserProfile)